module.exports = __webpack_public_path__ + "static/media/hot_cuppy.a74a0261.jpeg";